<template>
  <div :class="{ 'cancelled-event': isCancelled }">
    {{ eventName }}
  </div>
</template>

<script>
export default {
  name: 'EventNameComponent',
  props: {
    eventName: {
      type: String,
      default: '',
    },
    isCancelled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.cancelled-event {
  text-decoration: line-through;
  opacity: 0.7;
}
</style>
